import ccd_WModulo10 from "./ccd_WModulo10";
import ccd_UPC_E_to_A from "./ccd_UPC_E_to_A";
import ccd_Modulo43 from "./ccd_Modulo43";
import ccd_WModulo47 from "./BarcodeCCD_WModulo47";
import ccd_WModulo103 from "./BarcodeCCD_WModulo103";

function onBarCodeBlur(value, stringType, stringCalc, stringSize) {
  var intType = parseInt(stringType); //0
  var intCalc = parseInt(stringCalc); //3
  var intSize = parseInt(stringSize); //7
  var oHidden, strCode, strCheck, strCalcCheck, strUPACode;
  var blnError, chrTemp, strValue, aCodes;
  var intCheckDigits;

  strValue = value;

  if (intType == 2) intCheckDigits = 2;
  else intCheckDigits = 1;

  if (intCalc == 3) {
    if (strValue.length == intSize - intCheckDigits) {
      // if (
      //   confirm(
      //     "You have not specified a check digit. Would you like this to be calculated?"
      //   )
      // )
      //   intCalc = 1;
      // else {
      //   return;
      // }
    } else if (strValue.length == intSize) intCalc = 0;
    else {
      return "Incorrect number of characters.";
    }
  }
  // Split code and check digits if validating
  if (intCalc == 0) {
    if (intType == 2) {
      // Code 93 has two check digits
      strCode = value.substr(0, value.length - 2);
      strCheck = value.substr(value.length - 2);
    } else if (intType == 3 || intType == 6) {
      // 128 codes are comma seperated
      aCodes = value.split(",");
      strCheck = aCodes[aCodes.length - 1];
      aCodes.length = aCodes.length - 1;
      strCode = aCodes.join(",");
    } else {
      strCode = value.substr(0, value.length - 1);
      strCheck = value.substr(value.length - 1);
    }
  } else {
    strCode = value;
    strCheck = "";
  }

  // Convert Code 39 and 93 text to upper case
  if (intType >= 0 && intType <= 2) {
    strCode = strCode.toUpperCase();
    strCheck = strCheck.toUpperCase();
  }

  // Validate format
  blnError = false;

  // Check number of characters
  switch (intType) {
    case 8: // UPC-A
      if (strCode.length != 11) blnError = true;
      break;
    case 9: // UPC-E
      if (strCode.length != 7) blnError = true;
      break;
    case 4: // EAN-8
      if (strCode.length != 7) blnError = true;
      break;
    case 5: // EAN-13
      if (strCode.length != 12) blnError = true;
      break;
    case 7: // Interleaved 2 of 5
      if (strCode.length % 2 == 0) strCode = "0" + strCode;
      break;
  }

  if (blnError) {
    return "Incorrect number of characters.";
  }
  // Check characters
  switch (intType) {
    // Check numeric fields
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
      for (var i = 0; i < strCode.length; i++) {
        if (strCode.charAt(i) < "0" || strCode.charAt(i) > "9") {
          return "Only numeric characters are allowed.";
        }
      }
      break;
    // Check Code 39 and Code 93 character sets
    case 0:
    case 1:
    case 2:
      for (i = 0; i < strCode.length; i++) {
        chrTemp = strCode.charAt(i);
        if (
          (chrTemp >= "0" && chrTemp <= "9") ||
          (chrTemp >= "A" && chrTemp <= "Z")
        ) {
          continue;
        }

        switch (chrTemp) {
          case "-":
          case ".":
          case " ":
          case "$":
          case "/":
          case "+":
          case "%":
            // continue;
            break;
        }

        if (intType == 2) {
          if (chrTemp == "(" || chrTemp == ")") continue;
        }

        return "Invalid character '" + chrTemp + "'.";
      }
      break;
  }

  // If we're to ignore the check digit, just set the value of the hidden field
  if (intCalc == 2) {
    oHidden.value = strCode;
    return;
  }

  // Calculate Check Digit
  switch (intType) {
    case 4:
    case 5:
    case 7:
    case 8:
      strCalcCheck = ccd_WModulo10(strCode);
      break;
    case 9:
      strUPACode = ccd_UPC_E_to_A(strCode);
      strCalcCheck = ccd_WModulo10(strUPACode);
      break;
    case 0:
    case 1:
      strCalcCheck = ccd_Modulo43(strCode);
      break;
    case 2:
      strCalcCheck = ccd_WModulo47(strCode);
      break;
    case 3:
    case 6:
      strCalcCheck = ccd_WModulo103(strCode);
      if (strCalcCheck.substr(0, 6) == "ERROR:") {
        return 'Invalid code "' + strCalcCheck.substr(6) + '".';
      }
      strCode += ",";
      break;
  }

  // Compare check digit if validating
  if (intCalc == 0) {
    if (strCheck != strCalcCheck) {
      return "The specified check digit does not match the calculated value.";
    }
  }

  // Set hidden field value
  //oHidden.value = strCode + strCalcCheck;
}

// New helper: returns computed barcode (code + check digit) or null if invalid
export function computeBarcodeWithCheckDigit(value, stringType, stringCalc, stringSize) {
  try {
    var intType = parseInt(stringType);
    var intCalc = parseInt(stringCalc);
    var intSize = parseInt(stringSize);
    var strCode, strCheck = "", strCalcCheck, strUPACode, aCodes;
    var intCheckDigits = intType === 2 ? 2 : 1;
    var strValue = value;

    // Determine calculation mode (force calculation when intCalc === 1)
    if (intCalc === 3) {
      if (strValue.length === intSize - intCheckDigits) {
        intCalc = 1;
      } else if (strValue.length === intSize) {
        intCalc = 0;
      } else {
        return null;
      }
    }

    if (intCalc === 0) {
      if (intType === 2) {
        strCode = value.substr(0, value.length - 2);
        strCheck = value.substr(value.length - 2);
      } else if (intType === 3 || intType === 6) {
        aCodes = value.split(",");
        strCheck = aCodes[aCodes.length - 1];
        aCodes.length = aCodes.length - 1;
        strCode = aCodes.join(",");
      } else {
        strCode = value.substr(0, value.length - 1);
        strCheck = value.substr(value.length - 1);
      }
    } else {
      strCode = value;
    }

    if (intType >= 0 && intType <= 2) {
      strCode = strCode.toUpperCase();
      strCheck = strCheck.toUpperCase();
    }

    // Basic length checks
    let blnError = false;
    switch (intType) {
      case 8: if (strCode.length !== 11) blnError = true; break;
      case 9: if (strCode.length !== 7) blnError = true; break;
      case 4: if (strCode.length !== 7) blnError = true; break;
      case 5: if (strCode.length !== 12) blnError = true; break;
      case 7: if (strCode.length % 2 === 0) strCode = "0" + strCode; break;
    }
    if (blnError) return null;

    // Character set checks
    switch (intType) {
      case 4: case 5: case 7: case 8: case 9:
        if (![...strCode].every(c => c >= "0" && c <= "9")) return null;
        break;
      case 0: case 1: case 2:
        for (let i = 0; i < strCode.length; i++) {
          const chrTemp = strCode.charAt(i);
          const ok =
            (chrTemp >= "0" && chrTemp <= "9") ||
            (chrTemp >= "A" && chrTemp <= "Z") ||
            "-. $/+%".includes(chrTemp) ||
            (intType === 2 && (chrTemp === "(" || chrTemp === ")"));
          if (!ok) return null;
        }
        break;
    }

   // if (intCalc === 2) return strCode; // Ignore check digit

    switch (intType) {
      case 4:
      case 5:
      case 7:
      case 8:
        strCalcCheck = ccd_WModulo10(strCode);
        break;
      case 9:
        strUPACode = ccd_UPC_E_to_A(strCode);
        strCalcCheck = ccd_WModulo10(strUPACode);
        break;
      case 0:
      case 1:
        strCalcCheck = ccd_Modulo43(strCode);
        break;
      case 2:
        strCalcCheck = ccd_WModulo47(strCode);
        break;
      case 3:
      case 6:
        strCalcCheck = ccd_WModulo103(strCode);
        if (strCalcCheck.substr(0, 6) === "ERROR:") return null;
        strCode += ",";
        break;
      default:
        return null;
    }

    if (intCalc === 0 && strCheck !== strCalcCheck) return null;

    return strCode + strCalcCheck;
  } catch {
    return null;
  }
}

export default onBarCodeBlur;
